module.exports = __webpack_public_path__ + "static/media/coffee.275622bb.png";